import withHelmet from '../HOC/withHelmet';
import BuddiesPage from '../components/buddies';

export default withHelmet(BuddiesPage, 'Build your buddy list');
